import 'Plugins/anchorLinksPlugin';

// initialize smooth anchor links
export default function initAnchors() {
	new SmoothScroll({
		anchorLinks: '.anchor-link',
		extraOffset: 0,
		wheelBehavior: 'none'
	});
}
